(function () {
  function initBulkSizes(root) {
    if (root.dataset.bfSafetyBulkReady === 'true') return;
    root.dataset.bfSafetyBulkReady = 'true';

    const inputs = Array.from(root.querySelectorAll('.bf-safety-bulk__quantity'));
    const total = root.querySelector('[data-bf-safety-bulk-total]');
    const addButton = root.querySelector('[data-bf-safety-bulk-add]');
    const status = root.querySelector('[data-bf-safety-bulk-status]');
    const openButton = root.querySelector('[data-bf-safety-bulk-open]');
    const closeButton = root.querySelector('[data-bf-safety-bulk-close]');
    const dialog = root.querySelector('[data-bf-safety-bulk-dialog]');

    if (!addButton || !openButton || !dialog) return;

    function openDialog() {
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      document.documentElement.classList.add('bf-safety-modal-open');
      closeButton?.focus();
    }

    function closeDialog() {
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    }

    openButton.addEventListener('click', openDialog);
    closeButton?.addEventListener('click', closeDialog);
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeDialog();
    });
    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('bf-safety-modal-open');
      openButton.focus();
    });
    dialog.addEventListener('cancel', function () {
      document.documentElement.classList.remove('bf-safety-modal-open');
    });

    const readQuantity = (input) => Math.max(0, parseInt(input.value, 10) || 0);

    function updateTotal() {
      const selected = inputs.reduce((sum, input) => sum + readQuantity(input), 0);
      total.textContent = selected;
      addButton.disabled = selected === 0;
      status.textContent = '';
    }

    inputs.forEach(function (input) {
      input.addEventListener('input', function () {
        if (readQuantity(input) !== Number(input.value)) input.value = readQuantity(input);
        updateTotal();
      });

      const size = input.closest('.bf-safety-bulk__size');
      size?.querySelector('[data-bf-safety-bulk-decrease]')?.addEventListener('click', function () {
        input.value = Math.max(0, readQuantity(input) - 1);
        updateTotal();
      });
      size?.querySelector('[data-bf-safety-bulk-increase]')?.addEventListener('click', function () {
        input.value = readQuantity(input) + 1;
        updateTotal();
      });
    });

    addButton.addEventListener('click', async function () {
      const items = inputs
        .map(function (input) {
          return { id: input.dataset.variantId, quantity: readQuantity(input) };
        })
        .filter(function (item) {
          return item.quantity > 0;
        });

      if (!items.length) return;

      addButton.disabled = true;
      addButton.textContent = addButton.dataset.loadingLabel;
      status.textContent = '';

      try {
        const shopRoot = window.Shopify?.routes?.root || '/';
        const response = await fetch(shopRoot + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items: items })
        });

        if (!response.ok) throw new Error('Cart request failed');
        window.location.assign(shopRoot + 'cart');
      } catch (error) {
        status.textContent = root.dataset.errorMessage;
        addButton.disabled = false;
        addButton.textContent = addButton.dataset.defaultLabel;
      }
    });

    updateTotal();
  }

  function initAll() {
    document.querySelectorAll('[data-bf-safety-bulk]').forEach(initBulkSizes);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
})();
